import { render, staticRenderFns } from "./recommendedEdit.vue?vue&type=template&id=0c263fe6&scoped=true"
import script from "./recommendedEdit.vue?vue&type=script&lang=js"
export * from "./recommendedEdit.vue?vue&type=script&lang=js"
import style0 from "./recommendedEdit.vue?vue&type=style&index=0&id=0c263fe6&prod&lang=css"
import style1 from "./recommendedEdit.vue?vue&type=style&index=1&id=0c263fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c263fe6",
  null
  
)

export default component.exports